import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import TextLink from 'LuxKit/TextLink'
import Group from 'components/utils/Group'
import useToggle from 'hooks/useToggle'
import LuxPlusBenefitsList from 'luxPlus/components/LuxPlusBenefitsList'
import useEnabledLuxPlusBenefits from 'luxPlus/hooks/useEnabledLuxPlusBenefits'

const INITIAL_VISIBLE_COUNT = 5

interface Props {
  benefits: Array<App.MemberSubscriptionBenefitItem>
}

function LuxPlusInvalidCardModalBenefits({ benefits }: Props) {
  const intl = useIntl()
  const [showAll, toggleShowAll] = useToggle(false)
  // Filter before slicing so the first few shown are all enabled for the region (as LuxPlusBenefitsModal does)
  const enabledBenefits = useEnabledLuxPlusBenefits(benefits)
  const visibleBenefits = useMemo(
    () => (showAll ? enabledBenefits : enabledBenefits.slice(0, INITIAL_VISIBLE_COUNT)),
    [enabledBenefits, showAll],
  )

  if (!enabledBenefits.length) return null

  const showMoreLabel = intl.formatMessage({
    id: 'LT_-HvyjWCXkMtDXteQH',
    defaultMessage: 'Show more',
    description: 'Link under the benefits list in the LuxPlus+ invalid card modal to show the rest of the member benefits',
  })
  const showLessLabel = intl.formatMessage({
    id: 'qHDnee3W-bn4e5I_Yn4d',
    defaultMessage: 'Show less',
    description: 'Link under the benefits list in the LuxPlus+ invalid card modal to collapse it back to the first few benefits',
  })

  return <Group direction="vertical" gap={12}>
    <Heading variant="heading6">
      {intl.formatMessage({
        id: 'gpBLWeYIW-TYfwIoXaph',
        defaultMessage: 'Your LuxPlus+ benefits',
        description: 'Heading above the list of LuxPlus+ membership benefits in the LuxPlus+ invalid card modal',
      })}
    </Heading>
    <Group direction="vertical" gap={8}>
      <LuxPlusBenefitsList kind="long" benefits={visibleBenefits} />
    </Group>
    {enabledBenefits.length > INITIAL_VISIBLE_COUNT && <TextLink size="caption" onClick={toggleShowAll}>
      {showAll ? showLessLabel : showMoreLabel}
    </TextLink>}
  </Group>
}

export default LuxPlusInvalidCardModalBenefits
